module.exports = __webpack_public_path__ + "img/ball.dfdad0ee.png";